module.exports = __webpack_public_path__ + "static/img/Blaize-Talagi.693c0ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Blaize-Talagi.jpg
// module id = ek7o
// module chunks = 0